<template>
  <button
    class="back-to-top"
    @click="scrollToTop"
  >
    <BackToTopArrow
      ref="icon"
      class="back-to-top__icon"
    />
    <div class="back-to-top__label">
      {{ $config.common.scrollTop }}
    </div>
  </button>
</template>
<script>
import BackToTopArrow from '@/assets/images/decors/icons/back-to-top.svg?inline';

export default {
  name: 'BackToTop',
  components: {
    BackToTopArrow,
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.back-to-top {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 10px auto;
  color: white;
  text-transform: uppercase;
  gap: 6px;
  font-size: 15px;
  cursor: pointer;

  &__icon {
    transition: transform 0.3s;
  }
  &:hover {
    .back-to-top__icon {
      transform: translateY(-5px);
    }
  }
}
</style>
